import React from 'react';
import {Create} from 'admin-on-rest';
import ReportForm from './ReportForm';
import { CardActions } from 'material-ui/Card';

import IconTitle from '../components/icon_title';

const EmptyActions = ({ basePath, data, refresh }) => (
    <CardActions style={{ float: 'right' }}/>
);

export const SalesReportList = (props) => (
  <Create {...props} actions={<EmptyActions/>} title={<IconTitle icon="marketers" title={"resources.reports.sales.name"} />}>
    <ReportForm {...props} />
  </Create>
);



// WEBPACK FOOTER //
// ./src/reports/Sales.js